import {
    IUserTransferTargetBatch,
    IUserTransferTargetCurriculum,
    IUserTransferTargetSection,
    IUserTransferTargetTrack,
} from 'holberton-school-intranet-api';
import * as React from 'react';
import { ChangeEvent, ReactElement, useEffect, useState } from 'react';

export interface IProps {
    targets: IUserTransferTargetCurriculum[];
}

export default function UserTransferTargetSelector({
    targets,
}: IProps): ReactElement {
    const [selectedCurriculum, setSelectedCurriculum] = useState<
        IUserTransferTargetCurriculum
    >(targets.find((c) => c.current) || targets[0]);
    const [
        selectedTrack,
        setSelectedTrack,
    ] = useState<IUserTransferTargetTrack | null>(null);
    const [
        selectedBatch,
        setSelectedBatch,
    ] = useState<IUserTransferTargetBatch | null>(null);
    const [
        selectedSection,
        setSelectedSection,
    ] = useState<IUserTransferTargetSection | null>(null);

    useEffect(() => {
        setSelectedTrack(
            selectedCurriculum.tracks.find((t) => t.current) ||
                selectedCurriculum.tracks[0] ||
                null,
        );

        setSelectedBatch(selectedCurriculum.batches[0]);
    }, [selectedCurriculum]);

    useEffect(() => {
        if (selectedBatch) {
            setSelectedSection(
                selectedBatch.sections.find((s) => s.current) ||
                    selectedBatch.sections[0],
            );
        }
    }, [selectedBatch]);

    return (
        <>
            <div className="field">
                <label htmlFor="select-curriculum">Curriculum: </label>
                <select
                    className="form-control"
                    id="select-curriculum"
                    name="user_transfer_request[curriculum_id]"
                    onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                        setSelectedCurriculum(
                            targets.find(
                                (c) => c.id.toString() === e.target.value,
                            ),
                        );
                    }}
                    required={true}
                    value={selectedCurriculum.id}
                >
                    {targets.map((curriculum) => (
                        <option
                            key={curriculum.id.toString()}
                            value={curriculum.id}
                        >
                            {`${curriculum.name}${
                                curriculum.current ? ' (current)' : ''
                            }`}
                        </option>
                    ))}
                </select>
            </div>

            {selectedTrack && (
                <div className="field">
                    <label htmlFor="select-track">Track access: </label>
                    <select
                        className="form-control"
                        id="select-track"
                        name="user_transfer_request[track_id]"
                        onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                            setSelectedTrack(
                                selectedCurriculum.tracks.find(
                                    (t) => t.id.toString() === e.target.value,
                                ),
                            );
                        }}
                        required={true}
                        value={selectedTrack.id}
                    >
                        {selectedCurriculum.tracks.map((track) => (
                            <option key={track.id.toString()} value={track.id}>
                                {`${track.name} ${
                                    track.current ? '(current)' : ''
                                }`}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {selectedBatch && (
                <div className="field">
                    <label htmlFor="select-batch">Cohort: </label>
                    <select
                        className="form-control"
                        id="select-batch"
                        name="user_transfer_request[batch_id]"
                        onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                            setSelectedBatch(
                                selectedCurriculum.batches.find(
                                    (b) => b.id.toString() === e.target.value,
                                ),
                            );
                        }}
                        required={true}
                        value={selectedBatch.id}
                    >
                        {selectedCurriculum.batches.map((batch) => (
                            <option key={batch.id.toString()} value={batch.id}>
                                {batch.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {selectedSection && (
                <div className="field">
                    <label htmlFor="select-section">Section: </label>
                    <select
                        className="form-control"
                        id="select-section"
                        name="user_transfer_request[section_index]"
                        onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                            setSelectedSection(
                                selectedBatch.sections.find(
                                    (s) =>
                                        s.index.toString() === e.target.value,
                                ),
                            );
                        }}
                        required={true}
                        value={selectedSection.index}
                    >
                        {selectedBatch.sections.map((section) => (
                            <option
                                key={section.index.toString()}
                                value={section.index}
                            >
                                {`#${section.index + 1} -
                                ${section.start_date}
                                ${section.current ? '(current)' : ''}`}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </>
    );
}
